import type { AppDispatch, RootState } from '@/store';
import { combineReducers } from '@reduxjs/toolkit';
import assetReducer from 'features/assets';
import authReducer from 'features/Auth';
import chargePointReducer from 'features/ChargePoints';
import chargingProfileReducer from 'features/ChargingProfiles';
import collectionNoteReducer from 'features/CollectionNotes';
import commonReducer from 'features/Common';
import connectorReducer from 'features/Connectors';
import gridConnectionReducer from 'features/GridConnections';
import settingsReducer from 'features/Settings';
import trackerLogReducer from 'features/TrackerLogs';
import transactionReducer from 'features/Transactions';
import vehicleReducer from 'features/Vehicles';
import widgetReducer from 'features/Widgets';
import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';

import chargingAuthorizationsReducer from './ChargingAuthorizations';
import companyReducer from './Company';
import downloadsReducer from './Downloads';
import fleetsReducer from './Fleets';
import notificationsReducer from './Notifications';
import paymentsReducer from './Payments';
import uptimeReducer from './Uptime';
import userSessionReducer from './user-session';

const RESET_STORE = 'reset_store';

export const resetStore = () => ({ type: RESET_STORE });

export const combinedReducer = combineReducers({
  common: commonReducer,
  settings: settingsReducer,
  widgets: widgetReducer,
  auth: authReducer,
  assets: assetReducer,
  gridConnections: gridConnectionReducer,
  chargePoints: chargePointReducer,
  connectors: connectorReducer,
  transactions: transactionReducer,
  vehicles: vehicleReducer,
  trackerLogs: trackerLogReducer,
  chargingProfiles: chargingProfileReducer,
  notifications: notificationsReducer,
  company: companyReducer,
  fleets: fleetsReducer,
  downloads: downloadsReducer,
  uptime: uptimeReducer,
  chargingAuthorizations: chargingAuthorizationsReducer,
  collectionNotes: collectionNoteReducer,
  payments: paymentsReducer,
  userSession: userSessionReducer,
});

const rootReducer = (state: any, action: { type: string; payload: any; meta: any }) => {
  if (action.type === RESET_STORE) return combinedReducer(undefined, action);
  return combinedReducer(state, action);
};

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default rootReducer;
